import React from 'react';
import { Link } from 'react-router-dom';
import { FaEye, FaArrowRight } from 'react-icons/fa';

const galleryImages = [
  // '/galleryy/2.jpg',
  '/gallery/2.jpg',
  '/gallery/3.jpg',
  '/gallery/7.jpg',
  '/gallery/4.jpg',
  '/gallery/1.jpg',
  '/gallery/12.jpg',

];

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="auto-container">

        {/* Footer Gallery */}
        <div className="footer-gallery">
          <div className="row">
            {galleryImages.map((img, index) => (
              <div className="col-lg-2 col-md-4 col-sm-6" key={index}>
                <div className="image gallery-overlay">
                  <div className="inner-box">
                    <img src={`/images/${img}`} alt={`footer-${index + 1}`} />
                    <div className="overlay-box">
                      <div className="overlay-inner">
                        <div className="content">
                          <a
                            href={`/images/${img}`}
                            className="lightbox-image link"
                            data-fancybox="gallery"
                          >
                            <span className="icon"><FaEye /></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Widgets Section */}
        <div className="widgets-section">
          <div className="row clearfix">

            {/* Contact Info */}
            {/* <div className="column col-lg-4">
              <div className="widget contact-widget">
                <div className="image">
                  <Link to="/">
                    <img src="/images/logo.jpg" alt="Woodland Escape Resort" />
                  </Link>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <td className="lebel">Call :</td>
                      <td><a href="tel:+919175577266">+91 9175577266</a></td>
                    </tr>
                    <tr>
                      <td className="lebel">Email :</td> 
                      <td><a href="mailto:woodlandescape01@gmail.com">woodlandescape01@gmail.com</a></td>
                    </tr>
                    <tr>
                      <td className="lebel">Location&nbsp;:</td>
                      <td>
                        Woodland Escape Resort, Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - 441401
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div> */}

<div className="column col-lg-4">
  <div className="widget contact-widget">
    <div className="image">
      <Link to="/">
        <img src="/images/logo.jpg" alt="Woodland Escape Resort" />
      </Link>
    </div>

    <div className="contact-info">
      <div className="info-item">
        <span className="label">Call :</span>
        <a href="tel:+919175577266">+91 9175577266</a>
      </div>

      <div className="info-item">
        <span className="label">Email :</span>
        <a href="mailto:woodlandescape01@gmail.com">woodlandescape01@gmail.com</a>
      </div>

      <div className="info-item">
        <span className="label">Location :</span>
        <span>
          Woodland Escape, Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - 441401
        </span>
      </div>
    </div>
  </div>
</div>



            {/* Quick Links */}
            <div className="column col-lg-3">
              <div className="widget links-widget">
                <h3 className="widget-title">Quick Links</h3>
                <div className="widget-content">
                  <ul>
                    <li><Link to="/">Experience</Link></li>
                    <li><Link to="/rooms">Rooms</Link></li>
                    <li><Link to="/package">Packages</Link></li>
                       <li><Link to="/Near-by-Attractions">Attraction</Link></li>
                    <li><Link to="Term-condition">Terms & Conditions</Link></li>
                    <li><Link to="/Privacy-policy">Privacy Policy</Link></li>
                 
                  </ul>
               
<Link className="mx-md-2 d-none" to="/One-Day-Tour-Near-Nagpur">
  <i className="fas fa-umbrella-beach darkcolor"></i> 1 Day Tour Near Nagpur
</Link>
<Link className="mx-md-2 d-none" to="/Best‑Picnic‑Spot‑Near‑Nagpur">
  <i className="fas fa-umbrella-beach darkcolor"></i> Best Picnic Spot Near Nagpur
</Link>
<Link className="mx-md-2 d-none" to="/Family-Picnic-Spot-Near-Nagpur">
  <i className="fas fa-umbrella-beach darkcolor"></i> Family Picnic Spot Near Nagpur
</Link>
<Link className="mx-md-2 d-none" to="/Nearest-Picnic-Spot-In-Nagpur">
  <i className="fas fa-umbrella-beach darkcolor"></i> Nearest Picnic Spot in Nagpur
</Link>
<Link className="mx-md-2 d-none" to="/Destination-Wedding-Spots-Near-Nagpur">
  <i className="fas fa-umbrella-beach darkcolor"></i> Destination Wedding Spots Near Nagpur
</Link>
<Link className="mx-md-2 d-none" to="/Pre-Wedding-Destination-Near-Nagpur">
  <i className="fas fa-umbrella-beach darkcolor"></i> Pre Wedding Destination Near Nagpur
</Link>
<Link className="mx-md-2 d-none" to="/One-Day-Adventure-Resorts-Near-Nagpur">
  <i className="fas fa-umbrella-beach darkcolor"></i> One Day Adventure Resorts Near Nagpur
</Link>
<Link className="mx-md-2 d-none" to="/Activities-Resort-Near-Nagpur">
  <i className="fas fa-umbrella-beach darkcolor"></i> Activities Resort Near Nagpur
</Link>
<Link className="mx-md-2 d-none" to="/Best-Picnic-Spot-Near-Akola">
  <i className="fas fa-umbrella-beach darkcolor"></i> Best Picnic Spot Near Akola
</Link>
<Link className="mx-md-2 d-none" to="/One-Day-Tour-Near-Akola">
  <i className="fas fa-umbrella-beach darkcolor"></i> One Day Tour Near Akola
</Link>
<Link className="mx-md-2 d-none" to="/Resorts-Near-Akola-For-Family">
  <i className="fas fa-umbrella-beach darkcolor"></i> Resorts Near Akola for Family
</Link>
<Link className="mx-md-2 d-none" to="/Destination-Wedding-Resorts-Near-Akola">
  <i className="fas fa-umbrella-beach darkcolor"></i> Destination Wedding Resorts Near Akola
</Link>
<Link className="mx-md-2 d-none" to="/Best-Picnic-Spot-Near-Amravati">
  <i className="fas fa-umbrella-beach darkcolor"></i> Best Picnic Spot Near Amravati
</Link>
<Link className="mx-md-2 d-none" to="/One-Day-Tour-Near-Amravati">
  <i className="fas fa-umbrella-beach darkcolor"></i> One Day Tour Near Amravati
</Link>
<Link className="mx-md-2 d-none" to="/Family-Resorts-Near-Amravati">
  <i className="fas fa-umbrella-beach darkcolor"></i> Family Resorts Near Amravati
</Link>
<Link className="mx-md-2 d-none" to="/Pre-Wedding-Location-Near-Amravati">
  <i className="fas fa-umbrella-beach darkcolor"></i> Pre-wedding Location Near Amravati
</Link>
<Link className="mx-md-2 d-none" to="/Picnic-Spot-Near-Bhandara">
  <i className="fas fa-umbrella-beach darkcolor"></i> Picnic Spot Near Bhandara
</Link>
<Link className="mx-md-2 d-none" to="/One-Day-Trip-Near-Bhandara">
  <i className="fas fa-umbrella-beach darkcolor"></i> One Day Trip Near Bhandara
</Link>
<Link className="mx-md-2 d-none" to="/Resorts-Near-Bhandara-For-Family-Outing">
  <i className="fas fa-umbrella-beach darkcolor"></i> Resorts Near Bhandara for Family Outing
</Link>
<Link className="mx-md-2 d-none" to="/Destination-Wedding-Place-Near-Bhandara">
  <i className="fas fa-umbrella-beach darkcolor"></i> Destination Wedding Place Near Bhandara
</Link>
<Link className="mx-md-2 d-none" to="/Best-Picnic-Spot-Near-Buldhana">
  <i className="fas fa-umbrella-beach darkcolor"></i> Best Picnic Spot Near Buldhana
</Link>
<Link className="mx-md-2 d-none" to="/One-Day-Tour-Near-Buldhana">
  <i className="fas fa-umbrella-beach darkcolor"></i> One Day Tour Near Buldhana
</Link>
<Link className="mx-md-2 d-none" to="/Family-Resorts-Near-Buldhana">
  <i className="fas fa-umbrella-beach darkcolor"></i> Family Resorts Near Buldhana
</Link>
<Link className="mx-md-2 d-none" to="/Wedding-Destination-Near-Buldhana">
  <i className="fas fa-umbrella-beach darkcolor"></i> Wedding Destination Near Buldhana
</Link>
<Link className="mx-md-2 d-none" to="/Picnic-Spot-Near-Chandrapur">
  <i className="fas fa-umbrella-beach darkcolor"></i> Picnic Spot Near Chandrapur
</Link>
<Link className="mx-md-2 d-none" to="/One-Day-Tour-Near-Chandrapur">
  <i className="fas fa-umbrella-beach darkcolor"></i> One Day Tour Near Chandrapur
</Link>
<Link className="mx-md-2 d-none" to="/Adventure-Resorts-Near-Chandrapur">
  <i className="fas fa-umbrella-beach darkcolor"></i> Adventure Resorts Near Chandrapur
</Link>
<Link className="mx-md-2 d-none" to="/Destination-Wedding-Resort-Near-Chandrapur">
  <i className="fas fa-umbrella-beach darkcolor"></i> Destination Wedding Resort Near Chandrapur
</Link>
<Link className="mx-md-2 d-none" to="/Picnic-Spot-Near-Gadchiroli">
  <i className="fas fa-umbrella-beach darkcolor"></i> Picnic Spot Near Gadchiroli
</Link>
<Link className="mx-md-2 d-none" to="/One-Day-Trip-Near-Gadchiroli">
  <i className="fas fa-umbrella-beach darkcolor"></i> One Day Trip Near Gadchiroli
</Link>
<Link className="mx-md-2 d-none" to="/Family-Resort-Near-Gadchiroli">
  <i className="fas fa-umbrella-beach darkcolor"></i> Family Resort Near Gadchiroli
</Link>
<Link className="mx-md-2 d-none" to="/Pre-Wedding-Destination-Near-Gadchiroli">
  <i className="fas fa-umbrella-beach darkcolor"></i> Pre-wedding Destination Near Gadchiroli
</Link>
<Link className="mx-md-2 d-none" to="/Best-Picnic-Spot-Near-Gondia">
  <i className="fas fa-umbrella-beach darkcolor"></i> Best Picnic Spot Near Gondia
</Link>
<Link className="mx-md-2 d-none" to="/One-Day-Tour-Near-Gondia">
  <i className="fas fa-umbrella-beach darkcolor"></i> One Day Tour Near Gondia
</Link>
<Link className="mx-md-2 d-none" to="/Family-Resorts-Near-Gondia">
  <i className="fas fa-umbrella-beach darkcolor"></i> Family Resorts Near Gondia
</Link>
<Link className="mx-md-2 d-none" to="/Destination-Wedding-Resorts-Near-Gondia">
  <i className="fas fa-umbrella-beach darkcolor"></i> Destination Wedding Resorts Near Gondia
</Link>
<Link className="mx-md-2 d-none" to="/Picnic-Spot-Near-Wardha">
  <i className="fas fa-umbrella-beach darkcolor"></i> Picnic Spot Near Wardha
</Link>
<Link className="mx-md-2 d-none" to="/One-Day-Tour-Near-Wardha">
  <i className="fas fa-umbrella-beach darkcolor"></i> One Day Tour Near Wardha
</Link>
<Link className="mx-md-2 d-none" to="/Family-Resorts-Near-Wardha">
  <i className="fas fa-umbrella-beach darkcolor"></i> Family Resorts Near Wardha
</Link>
<Link className="mx-md-2 d-none" to="/Wedding-Destination-Near-Wardha">
  <i className="fas fa-umbrella-beach darkcolor"></i> Wedding Destination Near Wardha
</Link>
<Link className="mx-md-2 d-none" to="/Picnic-Spot-Near-Washim">
  <i className="fas fa-umbrella-beach darkcolor"></i> Picnic Spot Near Washim
</Link>
<Link className="mx-md-2 d-none" to="/One-Day-Trip-Near-Washim">
  <i className="fas fa-umbrella-beach darkcolor"></i> One Day Trip Near Washim
</Link>
<Link className="mx-md-2 d-none" to="/Resorts-Near-Washim-For-Family">
  <i className="fas fa-umbrella-beach darkcolor"></i> Resorts Near Washim for Family
</Link>
<Link className="mx-md-2 d-none" to="/Destination-Wedding-Near-Washim">
  <i className="fas fa-umbrella-beach darkcolor"></i> Destination Wedding Near Washim
</Link>
<Link className="mx-md-2 d-none" to="/Best-Picnic-Spot-Near-Yavatmal">
  <i className="fas fa-umbrella-beach darkcolor"></i> Best Picnic Spot Near Yavatmal
</Link>
<Link className="mx-md-2 d-none" to="/One-Day-Tour-Near-Yavatmal">
  <i className="fas fa-umbrella-beach darkcolor"></i> One Day Tour Near Yavatmal
</Link>
<Link className="mx-md-2 d-none" to="/Family-Resorts-Near-Yavatmal">
  <i className="fas fa-umbrella-beach darkcolor"></i> Family Resorts Near Yavatmal
</Link>
<Link className="mx-md-2 d-none" to="/Pre-Wedding-Resort-Near-Yavatmal">
  <i className="fas fa-umbrella-beach darkcolor"></i> Pre-wedding Resort Near Yavatmal
</Link>
<Link className="mx-md-2 d-none" to="/Luxury-Resort-In-Nagpur-District-With-Forest-View">
  <i className="fas fa-umbrella-beach darkcolor"></i> Luxury Resort in Nagpur District with Forest View
</Link>
<Link className="mx-md-2 d-none" to="/Adventure-Resort-In-Nagpur-District-With-Tiger-Safari">
  <i className="fas fa-umbrella-beach darkcolor"></i> Adventure Resort in Nagpur District with Tiger Safari
</Link>
<Link className="mx-md-2 d-none" to="/Family-Resort-In-Nagpur-District-Surrounded-By-Nature">
  <i className="fas fa-umbrella-beach darkcolor"></i> Family Resort in Nagpur District Surrounded by Nature
</Link>
<Link className="mx-md-2 d-none" to="/Couple-Resort-In-Nagpur-District-In-Jungle">
  <i className="fas fa-umbrella-beach darkcolor"></i> Couple Resort in Nagpur District in Jungle
</Link>
<Link className="mx-md-2 d-none" to="/Private-Resort-In-Nagpur-District-With-Swimming-Pool">
  <i className="fas fa-umbrella-beach darkcolor"></i> Private Resort in Nagpur District with Swimming Pool
</Link>
<Link className="mx-md-2 d-none" to="/Eco-Friendly-Resort-In-Nagpur-District">
  <i className="fas fa-umbrella-beach darkcolor"></i> Eco-friendly Resort in Nagpur District
</Link>
<Link className="mx-md-2 d-none" to="/Resort-In-Nagpur-District-With-Outdoor-Activities">
  <i className="fas fa-umbrella-beach darkcolor"></i> Resort in Nagpur District with Outdoor Activities
</Link>
<Link className="mx-md-2 d-none" to="/Farm-Stay-In-Nagpur">
  <i className="fas fa-umbrella-beach darkcolor"></i> Farm Stay in Nagpur
</Link>
<Link className="mx-md-2 d-none" to="/Nature-Resort-In-Nagpur">
  <i className="fas fa-umbrella-beach darkcolor"></i> Nature Resort in Nagpur
</Link>
<Link className="mx-md-2 d-none" to="/Adventure-Sports-Resort-In-Nagpur-District">
  <i className="fas fa-umbrella-beach darkcolor"></i> Adventure Sports Resort in Nagpur District
</Link>
<Link className="mx-md-2 d-none" to="/Pre-Wedding-Resort-In-Nagpur-District-In-Forest">
  <i className="fas fa-umbrella-beach darkcolor"></i> Pre-wedding Resort in Nagpur District in Forest
</Link>
<Link className="mx-md-2 d-none" to="/Resort-In-Nagpur-District-For-Corporate-Outings">
  <i className="fas fa-umbrella-beach darkcolor"></i> Resort in Nagpur District for Corporate Outings
</Link>

                </div>
              </div>
            </div>

            {/* Newsletter */}
            {/* <div className="column col-lg-5">
              <div className="widget newsletter-widget">
                <h3 className="widget-title">
                  Subscribe to Woodland Escape Resort updates <br /> for exclusive offers, special events, and resort news.
                </h3>
                <div className="widget-content">
                  <div className="newsletter-form">
                    <form className="ajax-sub-form" method="post">
                      <div className="form-group">
                        <input
                          type="email"
                          placeholder="Enter your email address"
                          id="subscription-email"
                        />
                        <button type="submit" className="theme-btn">
                          <FaArrowRight />
                        </button>
                        <label className="subscription-label" htmlFor="subscription-email"></label>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div> */}
{/* Newsletter / Resort CTA Replacement */}
<div className="column col-lg-5">
  <div className="widget newsletter-widget">
    <h3 className="widget-title">
      Plan Your Woodland Escape Adventure
    </h3>
    <div className="widget-content text-white">
      <p>
        Discover the magic of the forest, encounter majestic wildlife, and enjoy a serene retreat.  
        Book your stay today and experience an unforgettable journey at Woodland Escape.
      </p>
     <div className="link-btn">
  <a href="tel:+919175577266" className="theme-btn btn-style-one">
    <span>Call to Book</span>
  </a>
</div>

    </div>
  </div>
</div>

          </div>
        </div>

        <div className="auto-container">
          <div className="boder-bottom-four"></div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="auto-container">
            <div className="wrapper-box">
              <div className="copyright text-center">
                <div className="text">
                 
                  <p className="copyright-text text-white">
              © Copyright &copy;  <span className="darkcolorrr">Woodland Escape</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Dexter Intelligence</span>
              </a>
               {/* | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer"> <span className="darkcolorrr">&nbsp;Urva Hosting</span> </a> */}
              </p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
